export default "__VITE_ASSET__BB1AH_47__"